import { Outlet } from "react-router-dom";
import { WebNavFooter } from "../Output/WebNavFooter";
import { AppNavBar } from "../Output/AppNavBar";

import { DrawerStateProvider } from "../Trays/DrawerStateProvider";
import Drawer, { DrawerSlideEnum } from "../Trays/Drawer";
import Account from "../Trays/Account";

import { ModalStateProvider } from "../Modal/ModalStateProvider";
import ModalContainer from "../Modal/ModalContainer";
import { SwipeProvider } from "../Gestures/SwipeProvider";
import { SnackbarProvider } from "../Snackbars/SnackbarProvider";
import { SeoOptimizer } from "../../Analytics/SeoOptimizer ";
import { GoogleTag } from "../../Analytics/GoogleTag";

interface DesktopAppProps {
	showNav?: boolean;
}

export function DesktopApp({ showNav = true }: DesktopAppProps) {
	return (
		<SwipeProvider>
			<SeoOptimizer />
			<GoogleTag />
			<DrawerStateProvider>
				<ModalStateProvider>
					<SnackbarProvider>
						{/* DesktopTemplate inlined */}
						<div className="min-h-screen min-w-screen flex bg-primary-background text-primary">
							<div className="flex-1 flex flex-col">
								{/* HeaderLayout inlined */}
								<div className="flex flex-row items-center justify-center bg-primary-background text-primary">
									{/* Left column - equal width */}
									<div className="min-w-4"></div>

									{/* Middle column - main content area */}
									<div className="flex-1 flex flex-col pt-4 space-y-4">
										{/* Nav Header at top of middle column */}
										{showNav && <AppNavBar />}

										{/* Main content area */}
										<div className="flex-1">
											<Outlet />
										</div>
									</div>

									{/* Right column - equal width */}
									<div className="min-w-4"></div>
								</div>

								{/* Footer at bottom */}
								<WebNavFooter showContour={true} showLinks={false} />
							</div>
						</div>
						<Drawer position={DrawerSlideEnum.Left}>
							<Account />
						</Drawer>
						<ModalContainer />
					</SnackbarProvider>
				</ModalStateProvider>
			</DrawerStateProvider>
		</SwipeProvider>
	);
}
